import { Button, Card, FormControl, FormLabel, Input, Modal, ModalBody, ModalCloseButton, 
    ModalContent, ModalFooter, ModalHeader, ModalOverlay, Spinner, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react"; 
import Axios from "../utils/httpClient";
import Moment from "react-moment";
import styled from "styled-components";
 

const StyleContainer = styled.div`
    & .loading_target{
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px;
        margin-bottom: 20px;
    }
    & .app{
        margin-bottom: 20px;
        border: 1px solid;
        border-color: inherit;
        padding: 10px;
        border-radius: 0.375rem; 
        display: flex; 
        align-items: center;
        flex-direction: row;
        justify-content: space-between;
        & .ball{ 
            font-size: 18px;
            font-weight: bold;
            font-style: italic;
            color: #22C35E;
        }
        & .date{ 
            font-style: italic;
            font-size: 12px;
            margin-left: 10px;
        }
    }
`

const RectorIncentive = ({obj, onClose, apps=[], setApps=()=>{}, users=[], setUsers=()=>{}}) => {
    const toast = useToast();
    const [ball, setBall] = useState(100);
    const [loading, setLoading] = useState(false);
    const [iLoading, setILoading] = useState(false);
    const [err, setErr] = useState(false);
    const [incentive, setIncentive] = useState([]);
    useEffect(()=>{
        if(obj?.user){
            getAppsRector()
        }
    }, [obj?.user])
    const postBall = () => {
        setLoading(true);
        if(ball && ball>0){
            Axios().post('api/v1/application/rector-incentive/', {
                user_id: obj?.user,
                ball: +ball
            })
            .then(res=>{ 
                let l = [];
                apps.forEach(item => {
                    l.push(item);
                    if(item.id===obj.id){
                        l.push(res?.data);
                    }
                });
                setApps(l);
                let ul=[];
                users.forEach(item => {
                    if(item.id===obj.id){
                        ul.push({...item, ball: (item?.ball??0) + parseInt(ball)});
                    }else{
                        ul.push(item);
                    }
                });
                setUsers(ul);
                toast({
                    title: "Rektor Rag'batlantirishi",
                    description: `${ball} ball rag'bat berildi.`,
                    status: 'success',
                    duration: 3000,
                    isClosable: true,
                    position: 'top'
                });
                setBall(100);
                onClose();
            }).catch(e=>{
            }).finally(()=>{
                setLoading(false);
            })
        }else{
            setLoading(false);
            setErr(true)
        }
    }
    const getAppsRector = () => {
        setILoading(true)
        Axios().get(`api/v1/application/list/?user_id=${obj?.user}&is_rector_incentive=1`)
        .then(res=>{
            setIncentive(res?.data?.applications??[])
        }).finally(()=>{
            setILoading(false)
        })
    }
    return(<>
        <Modal isOpen={obj?.user??false} onClose={()=>onClose()} isCentered={true}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Rektor Rag'batlantirishi</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <StyleContainer>
                        {iLoading?<div>
                            <Card className="loading_target">
                                <Spinner  size='lg'
                                    thickness='4px'
                                    speed='0.65s'
                                    emptyColor='gray.200'
                                    color='rgb(34, 195, 94)'
                                />
                            </Card>
                        </div>:<>
                        {incentive.map((item, index)=>(
                            <Card className="app" key={index}>
                                <div className="ball">{item?.ball} Ball</div>
                                <div className="date"><Moment format="HH:mm DD-MM-YYYY">{item?.created_at}</Moment></div>
                            </Card>
                        ))}</>}
                    </StyleContainer>
                    { (incentive.length===0 && !iLoading )?<>
                        <FormControl>
                            <FormLabel>Rag'bat Balli</FormLabel>
                            <Input value={ball}  type={'number'}
                                onChange={(e)=>{setBall(e.target.value); setErr(false);}}
                            />
                            {err ? <FormLabel color={'red'}>Ballni kiriting</FormLabel> : null}
                        </FormControl>
                        <div style={{padding: '15px 0'}}>
                            <Button colorScheme='whatsapp' onClick={()=>postBall()} isLoading={loading}>
                                Rag'bat berish
                            </Button>
                        </div>
                    </>:""}
                </ModalBody> 
            </ModalContent>
        </Modal>
    </>)
}
export default RectorIncentive;